// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { LivetestGetTestResponse } from "../types";
import { createQueryKey } from "../utils/keys";

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const uploadNotificationMutationKey = ["uploadNotification"] as const;
export const startTestMutationKey = ["startTest"] as const;
export const patchTestMutationKey = ["patchTest"] as const;
export const postTestCopyPasteEventsMutationKey = [
  "postTestCopyPasteEvents",
] as const;
export const postTestFeedbackMutationKey = ["postTestFeedback"] as const;
export const finishTestMutationKey = ["finishTest"] as const;
export const tryTestMutationKey = ["tryTest"] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getTestQueryKey = (job_opening_slug: string, slug: string) =>
  createQueryKey<LivetestGetTestResponse>()([
    "jobopenings",
    job_opening_slug,
    "tests",
    slug,
  ] as const);
